module.exports = __webpack_public_path__ + "trust-marks-site-pro-news.496c4a.png";